<template>
  <div class="risk-assessment-row-wrapper">
    <div class="risk-assessment-row-item">
      <v-layout
        :id="`post-assessment-selection-${contentItem.name}`"
        class="flex items-center gap-3 risk-assessment-row"
      >
        <v-icon
          v-if="isChecklist && !contentItem.isNoRisk && !contentItem.isDangerSign"
          :size="20"
          :color="disabled ? '#5F6B70' : 'primary'"
          class="item-checkbox"
          :style="disabled ? { cursor: 'default' } : undefined"
          :tabindex="disabled ? -1 : undefined"
          :aria-disabled="String(disabled)"
          @click.stop="emitSelect"
        >
          {{ disabled ? mdiCheckboxOutline : checkboxIcon }}
        </v-icon>

        <v-icon :color="headerIconColor" class="triage-icon" small>{{ mdiCircle }}</v-icon>

        <div class="risk-assessment-row__content">
          <div style="line-height: normal">
            <mrx-translation
              v-if="contentItem.headerToken"
              class="treatment-header"
              :token="contentItem.headerToken"
            />

            <div
              v-for="(item, index) in contentItem.detailContent || []"
              :key="`${item}_${index}`"
            >
              <mrx-translation
                v-if="!contentItem.useHTMLFormat"
                class="assessment-light"
                :class="contentItem.headerToken ? 'treatment-text' : 'treatment-header'"
                :token="item"
              />
              <span
                v-else
                class="assessment-light"
                :class="contentItem.headerToken ? 'treatment-text' : 'treatment-header'"
                v-html="item"
              ></span>
            </div>
          </div>
        </div>

        <mrx-translation
          v-if="contentItem.noteToken"
          class="risk-assessment-row__note"
          :token="contentItem.noteToken"
        />

        <v-icon
          v-if="contentItem.isDangerSign"
          :size="18"
          color="#879799"
          class="risk-assessment-row__lock"
          :aria-label="$t('app.assessment_mode.risk_assessment.danger_sign.locked')"
        >
          {{ mdiLock }}
        </v-icon>
      </v-layout>
    </div>
  </div>
</template>

<script lang="ts">
import MrxTranslation from "@/components/thinkmd/mrx/translation.vue";
import { mdiCheckboxOutline, mdiCircle, mdiLock } from "@mdi/js";
import { defineComponent, PropType } from "vue";
import { ContentItem } from "../../types/overall-assessment.types";

export default defineComponent({
  name: "RiskAssessmentRow",
  components: { MrxTranslation },
  emits: ["select"],
  props: {
    contentItem: {
      type: Object as PropType<ContentItem>,
      required: true,
    },
    headerToken: {
      type: String,
      default: "",
    },
    headerIconColor: {
      type: String,
      default: "",
    },
    isChecklist: {
      type: Boolean,
      default: false,
    },
    checkboxIcon: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const emitSelect = (): void => {
      if (props.disabled) return;
      emit("select", props.contentItem.name);
    };

    return {
      mdiCheckboxOutline,
      mdiCircle,
      mdiLock,
      emitSelect,
    };
  },
});
</script>
